module.exports = __webpack_public_path__ + "img/skull_12.db74d023.png";